import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import { message } from 'antd';
import axios from 'axios';
var qs = require('qs');

//#region axios封装

//请求拦截器
var _requestInterceptor = function _requestInterceptor(instance) {
  instance.defaults.headers.common['Content-Type'] = 'application/json;charset=UTF-8';
  instance.interceptors.request.use( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(config) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            config.headers = _objectSpread({
              'Accept-Language': 'en-US'
            }, config.headers);
            // if (!config.headers.Authorization) {
            //   const storageMsgCentral: { token?: string; recipientId?: number } =
            //     getStorage(MSG_CENTRAL_STORAGE_KEY);
            //   config.headers.Authorization =
            //     storageMsgCentral?.token || (window as any).token;
            // }
            return _context.abrupt("return", config);
          case 2:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};

//响应拦截器
var _responseInterceptor = function _responseInterceptor(instance) {
  instance.interceptors.response.use(function (res) {
    return Promise.resolve(res.data);
  }, function (err) {
    var _err$response;
    return Promise.resolve({
      message: err.message || 'System is busy!',
      message_id: err.message_id || '9999',
      status: err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.status,
      result: false,
      object: null
    });
  });
};

//处理Get请求参数拼接
var _handleGetParams = function _handleGetParams(instance) {
  var _get = instance.get;
  instance.get = function (url, params, config) {
    return _get("".concat(url).concat(qs.stringify(params, {
      addQueryPrefix: true
    })), config);
  };
};
var createAxios = function createAxios() {
  var instance = axios.create({
    withCredentials: false,
    //跨域请求时是否需要使用凭证
    timeout: 120000
  });

  //请求拦截器
  _requestInterceptor(instance);
  //响应拦截器
  _responseInterceptor(instance);
  //处理Get请求参数拼接
  _handleGetParams(instance);
  return instance;
};
var instance = createAxios();
//#endregion

//获取请求域名
var getBaseUrl = function getBaseUrl(env) {
  var res = 'https://api.dev.sayweee.net';
  switch (env) {
    case 'tb1':
      res = 'https://api.tb1.sayweee.net';
      break;
    case 'prod':
      res = 'https://api.sayweee.net';
      break;
    default:
      break;
  }
  return res;
};
export default function request(options) {
  var doAxios;
  var url = options.url,
    _options$method = options.method,
    method = _options$method === void 0 ? 'get' : _options$method,
    params = options.params,
    _options$config = options.config,
    config = _options$config === void 0 ? {} : _options$config,
    showResMsg = options.showResMsg,
    _options$notShowResMs = options.notShowResMsg,
    notShowResMsg = _options$notShowResMs === void 0 ? true : _options$notShowResMs,
    _options$msgDuration = options.msgDuration,
    msgDuration = _options$msgDuration === void 0 ? 3 : _options$msgDuration,
    token = options.token,
    env = options.env;
  switch (method.toLowerCase()) {
    case 'post':
      doAxios = instance.post;
      break;
    case 'put':
      doAxios = instance.put;
      break;
    default:
      doAxios = instance.get;
  }
  var prefix = getBaseUrl(env);
  var realUrl = "".concat(prefix).concat(url);
  var configT = _objectSpread({
    headers: {
      Authorization: token ? "Bearer ".concat(token) : ''
    }
  }, config);
  return doAxios(realUrl, params, _objectSpread({}, configT)).then(function (response) {
    //根据response处理逻辑
    if (response.message_id === '10000') {
      if (showResMsg) {
        message.success(showResMsg, msgDuration);
      }
      return Promise.resolve(response);
    } else {
      if (notShowResMsg) return Promise.reject();
      var err = response.message || 'Sorry, System Error';
      message.error(err, msgDuration);
      return Promise.reject();
    }
  });
}